import { Injectable } from '@angular/core';
import { type HknIdentifier } from '@clean-code/models';
import {
  DataTableParameters,
  ID,
  PagingResponse
} from '@clean-code/models/common';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { EditSearchDataService } from '@clean-code/shared/util/util-data-service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class HknIdentifierService
  implements EditSearchDataService<HknIdentifier>
{

  private entityFields = `
    id
    identifier
    supplierId
    supplier{
        name
    }
    deliveryAreaId
    deliveryArea{
        name
    }
    hknTypeId
    hknType{
        name
    }
    year
  `;

  constructor(
    private graphqlService: GraphqlService,
  ) {
  }

  public getAll$(
    params: DataTableParameters,
  ): Observable<PagingResponse<HknIdentifier>> {
    return this.graphqlService.getAll(params, "hknIdentifierGetAll", this.entityFields);
  }

  public getById$(id: ID): Observable<HknIdentifier> {  
    return this.graphqlService.getById(id, "hknIdentifierGetById", this.entityFields);
  }


  public add$(hknIdentifier: HknIdentifier): Observable<ID> {
    const input = {
      identifier: hknIdentifier.identifier,
      year: hknIdentifier.year,
      hknTypeId: hknIdentifier.hknTypeId,
      supplierId: hknIdentifier.supplierId,
      deliveryAreaId: hknIdentifier.deliveryAreaId,
    };

    const mutation = `
        mutation ($input: AddHknIdentifierInput!){
          addHknIdentifier(input: $input)
        }`;

    return this.graphqlService.query<ID>(mutation, { input });
  }

  public update$(hknIdentifier: HknIdentifier) {
    const input = {
      id: hknIdentifier.id,
      identifier: hknIdentifier.identifier,
      year: hknIdentifier.year,
      hknTypeId: hknIdentifier.hknTypeId,
      supplierId: hknIdentifier.supplierId,
      deliveryAreaId: hknIdentifier.deliveryAreaId,
    };

    const mutation = `
        mutation ($input: UpdateHknIdentifierInput!){
          updateHknIdentifier(input: $input)
        }`;

    return this.graphqlService.query<number>(mutation, { input });
  }
  public delete$(id: ID) {
    const mutation = `
    mutation ($id: Int!){
      deleteHknIdentifier(id: $id)
      }`;

    return this.graphqlService.mutation<boolean>(mutation, { id });
  }
}
